module.exports = __webpack_public_path__ + "img/49a202a.png";